
<template>
    
        <mars-view v-if="recommendList && recommendList.length" class="relevant-case-container relevant-case-container-question"><mars-view v-for="(recommendInfo, index) in recommendList" :key="index" class="recommend-list-box"><case-item v-if="!recommendInfo.module" :case-info="recommendInfo" click-area="flwd_click"></case-item><template><mars-view v-if="index < 10 && aspH5Data && aspH5Data.wapqbmarketing && aspH5Data.wapqbmarketing.ad_place_data
                    && (index + 1) % 3 === 0 && (index + 1) / 3 <= aspH5Data.wapqbmarketing.ad_place_data.length" :id="'regulation-question-recommend-list-ad-top-' + ((index + 1) / 3 - 1)" class="legal-case-ad-area-h5" data-area="ad-1929" data-serverid="17017" @click.native.stop="adClick(0)"><mars-view v-if="recommendList.length !== index + 1" class="line"></mars-view><mars-view><law-ad-h5-case-list :ads-h5-change-item="{
                            ad_place_data: aspH5Data.wapqbmarketing.ad_place_data[((index + 1) / 3 - 1)],
                            ad_place_js: aspH5Data.wapqbmarketing.ad_place_js,
                            ad_place_css: aspH5Data.wapqbmarketing.ad_place_css,
                        }"></law-ad-h5-case-list></mars-view></mars-view></template><template><mars-view v-if="index > 10 && aspH5FeedData && aspH5FeedData.wapyouxchangeasp && aspH5FeedData.wapyouxchangeasp.ad_place_data
                    && (index + 1) % 3 === 0 && (((index + 1) / 3) - 4) <= aspH5FeedData.wapyouxchangeasp.ad_place_data.length" :id="'regulation-question-recommend-list-ad-' + (((index + 1) / 3) - 4)" class="legal-case-ad-area" data-area="ad-1930" data-serverid="17017" @click.native.stop="adClick(1)"><mars-view v-if="recommendList.length !== index + 1" class="line"></mars-view><mars-view><law-ad-h5-case-list :ads-h5-change-item="{
                            ad_place_data: aspH5FeedData.wapyouxchangeasp.ad_place_data[((index + 1) / 3) - 4],
                            ad_place_js: aspH5FeedData.wapyouxchangeasp.ad_place_js,
                            ad_place_css: aspH5FeedData.wapyouxchangeasp.ad_place_css,
                        }"></law-ad-h5-case-list></mars-view></mars-view></template><mars-view v-if="recommendList.length !== index + 1" class="line"></mars-view></mars-view></mars-view>
    
</template>

<script>
import caseItem from "./case-item.vue";
import LawAdH5CaseList from "../../../pages/qalandpage/iknow/law-ad-h5-case-list.vue";
import { inSightObservers } from '../../../common/js/repeatExposureLog.js';
import log from '../../../static/utils/ubcLog';
import { adAreaMap } from '../utils/commonData';
export default {
  components: {
    'case-item': caseItem,
    'law-ad-h5-case-list': LawAdH5CaseList
  },
  props: {
    // 推荐列表
    recommendList: {
      type: Array,
      default() {
        return [];
      }
    },
    // 广告
    aspFeedData: {
      type: Array,
      default() {
        return [];
      }
    },
    // 广告
    aspH5FeedData: {
      type: Object,
      default() {
        return {};
      }
    },
    aspH5Data: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  mounted() {
    this.adShowLog();
  },
  methods: {
    adShowLog() {
      if (!this.aspH5FeedData || !this.aspH5FeedData.wapyouxchangeasp) {
        this.adShowTimeout = setTimeout(() => {
          clearTimeout(this.adShowTimeout);
          this.adShowTimeout = null;
          this.adShowLog();
        }, 1500);
        return;
      }
      this.$nextTick(() => {
        setTimeout(() => {
          for (let i = 0; i < 7; i++) {
            inSightObservers.call(this, '#regulation-question-recommend-list-ad-' + i, '', {}, [], false, true, true, {
              threshold: 0.3
            });
          }
        }, 1500);
        setTimeout(() => {
          for (let i = 0; i < 3; i++) {
            inSightObservers.call(this, '#regulation-question-recommend-list-ad-top-' + i, '', {}, [], false, true, true, {
              threshold: 0.3
            });
          }
        }, 1500);
      });
    },
    adClick(index) {
      log.send && log.send({
        serverId: 17017,
        area: 'gg_click',
        action: 'click'
      });
      adAreaMap[+index] && log.send && log.send({
        serverId: 16866,
        area: adAreaMap[+index],
        action: 'click'
      });
    }
  }
};
</script>

<style scoped>
.relevant-case-container {
  margin-top: 1.93vw;
  padding-top: 4.83vw;
  background-color: #fff;
}
.relevant-case-container .case-title {
  font-family: PingFang SC;
  font-size: 4.59vw;
  color: #1e1f24;
  line-height: 4.59vw;
  font-weight: 700;
  padding: 0 4.11vw;
}
.relevant-case-container .line {
  margin: 0 4.11vw;
  border-bottom: 0.16vw solid #edeef0;
}
.relevant-case-container-question {
  width: calc(100% + 8.22vw);
  transform: translateX(-4.11vw);
  padding-top: 0;
}
 /deep/ .law-ads-container {
  padding-left: 4.11vw !important;
  padding-right: 4.11vw !important;
}
.legal-case-ad-area-h5 /deep/ .law-ads-container {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

</style>
